/*--------------------------------------------------------------
# FAQ Feed
# - each question toggles its answer open/closed independently
--------------------------------------------------------------*/

(function () {
	function initFaqFeed(root) {
		var items = Array.prototype.slice.call(root.querySelectorAll('.faq-feed__item'));

		items.forEach(function (item) {
			var button = item.querySelector('.faq-feed__question');

			if (!button) {
				return;
			}

			button.addEventListener('click', function () {
				var open = item.classList.toggle('is-open');
				button.setAttribute('aria-expanded', open ? 'true' : 'false');
			});
		});
	}

	function init() {
		Array.prototype.slice
			.call(document.querySelectorAll('.faq-feed'))
			.forEach(initFaqFeed);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
